function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.4098 10.5084H17.6198L16.0098 8.89844V10.1184C16.0098 10.3384 16.1898 10.5184 16.3998 10.5184L16.4098 10.5084Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3999 9.29V17.22C10.3999 17.66 10.7499 18.01 11.1899 18.01H17.2299C17.6599 18.01 18.0199 17.65 18.0199 17.22V11.3H16.4099C15.7599 11.3 15.2299 10.77 15.2299 10.11V8.5H11.1899C10.7499 8.5 10.3999 8.85 10.3999 9.29ZM11.5599 15.44C11.5599 15.22 11.7399 15.04 11.9499 15.04H16.4499C16.6699 15.04 16.8399 15.22 16.8399 15.44C16.8399 15.66 16.6599 15.84 16.4499 15.84H11.9499C11.7299 15.84 11.5599 15.66 11.5599 15.44ZM11.5599 13.33C11.5599 13.11 11.7399 12.93 11.9499 12.93H16.4499C16.6699 12.93 16.8399 13.11 16.8399 13.33C16.8399 13.55 16.6599 13.73 16.4499 13.73H11.9499C11.7299 13.73 11.5599 13.55 11.5599 13.33Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11 1.7125L6.11 0.0525C5.92 -0.0175 5.7 -0.0175 5.51 0.0525L0.63 1.7125C0.25 1.8425 0 2.1925 0 2.5925V6.3325C0 11.0425 5.23 13.3225 5.45 13.4225C5.57 13.4725 5.69 13.4925 5.82 13.4925C5.95 13.4925 6.07 13.4725 6.18 13.4225C6.29 13.3725 7.59 12.8025 8.9 11.6825V9.2925C8.9 8.0325 9.93 7.0025 11.19 7.0025H11.59C11.61 6.7825 11.64 6.5625 11.64 6.3325V2.5925C11.64 2.1925 11.39 1.8425 11.01 1.7125H11ZM7.7 7.1325H6.54V8.2825C6.54 8.6825 6.22 8.9925 5.82 8.9925C5.42 8.9925 5.1 8.6725 5.1 8.2825V7.1325H3.94C3.54 7.1325 3.22 6.8125 3.22 6.4225C3.22 6.0325 3.54 5.7125 3.94 5.7125H5.1V4.5625C5.1 4.1625 5.42 3.8525 5.82 3.8525C6.22 3.8525 6.54 4.1725 6.54 4.5625V5.7125H7.7C8.1 5.7125 8.42 6.0325 8.42 6.4225C8.42 6.8125 8.1 7.1325 7.7 7.1325Z"
});

function SvgIconCoverageTerm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoverageTerm);
export default __webpack_public_path__ + "static/media/icon-coverage-term.5824769b.svg";
export { ForwardRef as ReactComponent };